import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: "Shubham Choudhary",
    institution: "G H Raisoni College of Engineering and Technology Nagpur, BCA",
    rating: 5,
    quote: "This team can provide a knowledge and helpful for future and the most important thing is learn way",
  },
  {
    name: "Anushka Raj",
    institution: "Graphic Era Deemed to be University, BBA",
    rating: 4,
    quote: "It was very innovative and encouraging program. It help us to motivate and give the best result for the subject we have indulged in. Feeling very motivated by attending this training program.",
  },
  {
    name: "Eshika Garg",
    institution: "NMIMS, MBA",
    rating: 5,
    quote: "Internslite's live lectures provided an excellent learning experience, allowing real-time doubt clarification. The training teacher, especially, enriched our understanding of the corporate world effectively.",
  },
  {
    name: "Hritik",
    institution: "JCBOSE university of Science and Technology, (Management)",
    rating: 4,
    quote: "Overall training session was good, all basic concepts were discussed a student can gain insights of HR from base and can enhance his career in this field",
  },
  {
    name: "Vaishnavi Singh",
    institution: "Babu Banarasi Das University",
    rating: 5,
    quote: "My experience was overall good. It is a great learning platform and provides quality education and training programs. Otherwise everything was on the mark.",
  },
  {
    name: "Akanksha",
    institution: "JBU Science and Technology YMCA, Faridabad, (Management)",
    rating: 4,
    quote: "This course is very helpful as it increases our knowledge and skills and it also provides us two live projects in our training period.",
  },
];

function HR_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>
                  Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
                </p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, starIndex) => (
                          <li key={starIndex}>
                            <FaStar color={starIndex < review.rating ? "gold" : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.quote}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HR_Review_Program_Page;
